<template>
  <el-form
    :model="form"
    ref="form">
      <div class="row">
        <div class="col-md-4 col-sm-6 col-12">
          <el-form-item
            :label="L10n('rfqid')"
            prop="rfqid"
            :rules="getValidationRule('required,minLength')"
            class="material-style">
            <el-input
              ref="firstField"
              :value="form.rfqid"
              @input="form.rfqid = valueTrimLeft($event)"
              @change="updateModelItem('rfqid', { required: true })"
            />
          </el-form-item>
        </div>
        <div class="col-md-4 col-sm-6 col-12">
          <el-form-item
            :label="L10n('supplier-company')"
            prop="supplierCompanyID"
            :rules="getValidationRule('required')"
            class="material-style"
          >
            <select-company
              :model.sync="form.supplierCompanyID"
              @on-created="mixCreateSupplier"
              @on-change="(id) => mixChangeSupplierID(id, { required: true })"
            ></select-company>
          </el-form-item>
        </div>
        <div class="col-md-4 col-12">
          <el-form-item
            :label="L10n('supplier-contact')"
            prop="supplierContactID"
            class="material-style">

            <select-company-contact
              :model.sync="form.supplierContactID"
              :companyID="form.supplierCompanyID"
              @update:model="updateModelItem('supplierContactID', { required: false })"
            ></select-company-contact>
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-3 col-md-6 col-12">
          <el-form-item
            :label="L10n('part-number')"
            prop="partID"
            class="material-style"
            :rules="getValidationRule('required')"
          >
            <select-part-number
              :model.sync="form.partID"
              @update:model="updateModelItem('partID', { required: true })"
              @on-change="(id, data) => {form.partNumber = data && data.partNumber}"
            ></select-part-number>
          </el-form-item>
        </div>
        <div class="col-xl-3 col-md-6 col-12">
          <el-form-item
            :label="L10n('part-sn')"
            prop="partSN"
            class="material-style">
            <el-input
              ref="firstField"
              :value="form.partSN"
              @input="form.partSN = valueTrimLeft($event)"
              @change="updateModelItem('partSN', { required: false })"
            />
          </el-form-item>
        </div>
        <div class="col-xl-3 col-md-6 col-12">
          <el-form-item
            :label="L10n('condition')"
            prop="conditionID"
            class="material-style"
          >
            <select-response
              :model.sync="form.conditionID"
              @update:model="updateModelItem('conditionID', { required: false })"
              @on-change="(id) => form.conditionTitle = dataSourceCondition.map[id] && dataSourceCondition.map[id].title"
              :isLoading="dataSourceCondition.loading"
              :data="dataSourceCondition.records"
            ></select-response>
          </el-form-item>
        </div>
        <div class="col-xl-3 col-md-6 col-12">
          <el-form-item
            :label="L10n('employee')"
            prop="employeeID"
            class="material-style">
            <select-response
              :model.sync="form.employeeID"
              @update:model="updateModelItem('employeeID', { required: false })"
              :disabled="disabledEmployee"
              :data="dataSourceEmployee.records"
              :isLoading="dataSourceEmployee.isLoading"/>
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-1 col-md-3 col-6">
          <el-form-item
            :label="L10n('qty')"
            prop="qty"
            class="material-style"
            :rules="getValidationRule('required,number')"
          >
            <el-input
              :value="form.qty"
              @input="form.qty = valueNumber($event)"
              @change="updateModelItem('qty', { required: true })"
            />
          </el-form-item>
        </div>
        <div class="col-xl-2 col-md-6 col-6">
          <el-form-item
            :label="L10n('price')"
            prop="price"
            class="material-style"
            :rules="getValidationRule('required,number')"
          >
            <el-input
              :value="form.price"
              @input="form.price = valueNumber($event)"
              @change="updateModelItem('price', { required: true })"
            />
          </el-form-item>
        </div>
        <div class="col-xl-1 col-md-3 col-sm-4 col-6">
          <el-form-item
            prop="currencyID"
            :label="L10n('currency')"
            :rules="getValidationRule('required')"
            class="material-style"
          >
            <select-response
              :model.sync="form.currencyID"
              @update:model="updateModelItem('currencyID', { required: true })"
              @on-change="(id) => form.currencyTitle = dataSourceCurrency.map[id] && dataSourceCurrency.map[id].title"
              :isLoading="dataSourceCurrency.loading"
              :data="dataSourceCurrency.records"
            ></select-response>
          </el-form-item>
        </div>
        <div class="col-xl-4 col-md-6 col-6">
          <el-form-item
            :label="L10n('payment-term')"
            prop="paymentTermID"
            class="material-style">
            <select-response
              :model.sync="form.paymentTermID"
              @update:model="updateModelItem('paymentTermID', { required: false })"
              :isLoading="dataSourcePaymentTerm.loading"
              :data="dataSourcePaymentTerm.records"
            ></select-response>
          </el-form-item>
        </div>
        <div class="col-xl-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('release')"
            prop="releaseID"
            class="material-style"
          >
            <select-response
              :model.sync="form.releaseID"
              @update:model="updateModelItem('releaseID', { required: false })"
              :data="dataSourceRelease.records"
              :isLoading="dataSourceRelease.loading"
            ></select-response>
          </el-form-item>
        </div>
      </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { mixUpdateSupplier } from '@/mixins/companies'

export default {
  name: 'SupplierQuotesRFQ2',
  mixins: [Form, mixUpdateSupplier],
  components: {
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index.vue')
  },
  computed: {
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceRelease () {
      return this.API('Releases/GetAllDynamic?select=id,title')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourcePaymentTerm () {
      return this.API('PaymentTerms/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    },
    disabledEmployee () {
      return !this.$store.getters.isHighPermission
    }
  }
}
</script>
<style lang="stylus">
</style>
